/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesInvoiceStatus } from './WebApiModelsEnumerationTypesInvoiceStatus';
import {
    WebApiModelsEnumerationTypesInvoiceStatusFromJSON,
    WebApiModelsEnumerationTypesInvoiceStatusFromJSONTyped,
    WebApiModelsEnumerationTypesInvoiceStatusToJSON,
} from './WebApiModelsEnumerationTypesInvoiceStatus';

/**
 * 
 * @export
 * @interface WebApiAdminDtoSetInvoiceStatusDto
 */
export interface WebApiAdminDtoSetInvoiceStatusDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetInvoiceStatusDto
     */
    invoiceId?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesInvoiceStatus}
     * @memberof WebApiAdminDtoSetInvoiceStatusDto
     */
    status?: WebApiModelsEnumerationTypesInvoiceStatus;
}

/**
 * Check if a given object implements the WebApiAdminDtoSetInvoiceStatusDto interface.
 */
export function instanceOfWebApiAdminDtoSetInvoiceStatusDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSetInvoiceStatusDtoFromJSON(json: any): WebApiAdminDtoSetInvoiceStatusDto {
    return WebApiAdminDtoSetInvoiceStatusDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSetInvoiceStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSetInvoiceStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceId': !exists(json, 'invoiceId') ? undefined : json['invoiceId'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesInvoiceStatusFromJSON(json['status']),
    };
}

export function WebApiAdminDtoSetInvoiceStatusDtoToJSON(value?: WebApiAdminDtoSetInvoiceStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceId': value.invoiceId,
        'status': WebApiModelsEnumerationTypesInvoiceStatusToJSON(value.status),
    };
}

